import { createSelector, createSlice } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

type DeleteAllCardsModal = boolean;

const initialDeleteAllCardsModal: DeleteAllCardsModal = false;

const deleteAllCardsModalSlice = createSlice({
  name: "deleteAllCardsModal",
  initialState: initialDeleteAllCardsModal,
  reducers: {
    openDeleteAllCardsModalAction: () => {
      return true;
    },
    closeDeleteAllCardsModalAction: () => {
      return false;
    },
  },
});

const appBaseSelector = createBaseSelector(deleteAllCardsModalSlice);

registerSlice([deleteAllCardsModalSlice]);

export const deleteAllCardsModalStore = {
  actions: deleteAllCardsModalSlice.actions,
  selectors: {
    isDeleteAllCardsModalOpened: createSelector(appBaseSelector, (s) => s),
  },
};
